<div>
  <h1>Темы билетов ПДД 2026 — все темы с последними изменениями</h1>
</div>
<div>
  <ul class="list_category">
    <ng-container *ngFor="let theme of this.BilletsService.themes_list; let  i = index">
      <li>
        <a [routerLink]="['/', 'bilets-themes', theme.url]">
          <div class="sb-num">
            {{ i + 1 }}
          </div>
          <div>
            {{ theme.title }}
          </div>
        </a>
      </li>
    </ng-container>
  </ul>
</div>
